import { DocumentTemplateService } from '@fi-app/document-template/document-template.service';
import { Transition } from '@uirouter/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

export const FiDocumentStatesResolveDocumentTemplates = [
    DocumentTemplateService,
    Transition,
    FiDialogsService,
    AppTextService,
    FiDocumentStatesResolveDocumentTemplatesFunc,
];

export function FiDocumentStatesResolveDocumentTemplatesFunc(
    documentTemplateService: DocumentTemplateService,
    tr: Transition,
    fiDialogsService: FiDialogsService,
    appTextService: AppTextService,
) {
    return new Promise((resolve, reject) => {
        documentTemplateService.GetLightWeightTemplates().then((data) => {
            // check if user has any available template when create document
            if (tr.to().name === FiStateNames.Document.Add && !data.find((item) => item.HasViewAccess)) {
                fiDialogsService.notify({
                    messageText: appTextService.get('document.no_templates_error_text'),
                    headerText: appTextService.get('document.no_templates_error_header'),
                    yesButtonText: appTextService.get('common.understand_button_text'),
                });
                reject();
            } else {
                resolve(data);
            }
        }, reject);
    });
}
